<template>
	<form class="partial auth-verify"  @submit.prevent.stop="submitForm(fields)">

		<div class="form-row" v-if="!userClaims.mfaMethod && authData?.otpUri">
			<h4>Register Your Multi-Factor Authentication</h4>
			<p class="form__description">Scan the QR code below in your
					<NewTippy :options="{trigger:'click'}" style="display: inline-block;">
						<template v-slot:element>
							authenticator app <i class="material-icons material-icons--small pointer">help</i>
						</template>
						<template v-slot:content>
							<span>Such as <a href="https://support.google.com/accounts/answer/1066447?hl=en&co=GENIE.Platform%3DAndroid" target="_blank">Google Authenticator</a> or <a href="https://support.microsoft.com/en-us/account-billing/download-microsoft-authenticator-351498fc-850a-45da-b7b6-27e523b8702a" target="_blank">Microsoft Authenticator</a></span>
						</template>
					</NewTippy>
				to register your two-factor authentication method.</p>
			<div class="auth-verify__codes">
				<img :src="authData.otpQrCode" v-if="authData.otpQrCode" :alt="authData.otpSecret" />
				<a @click="viewCode = true" v-if="!viewCode">Or reveal the key here to enter manually</a> <span class="font-mono auth-verify__secret" v-if="viewCode">{{ authData.otpSecret }}</span>
			</div>
		</div>
		<div class="form-row" v-else>
			<h4>Verify Your Multi-Factor Authentication</h4>
			<p class="form__description">Enter the code from your authenticator app below.</p>
		</div>
		<div class="form-section">
			<div class="form-row">
				<TextField type="tel" v-model="fields.code" maxlength="6" pattern="[0-9]{6}" label="6-Digit Code" :disabled="isLoading" :required="true" autofocus="true" id="code" />
			</div>
		</div>

		<div class="form__message error" v-if="errorMessage">
			{{ errorMessage }}
		</div>

		<div class="form__actions form__actions--horizontal">
			<Button look="text" :disabled="isLoading" @click="cancel">cancel</Button>
			<Button type="submit" look="form" :disabled="isLoading || fields.code.length < 6" :loading="isLoading">Verify</Button>
		</div>

	</form>
</template>

<script>
import tippy from 'tippy.js'
import { useHead } from '@unhead/vue'
import { useUserStore } from '@/lib/store/user'

import Button from '@/components/Button.vue'
import NewTippy from '@/components/NewTippy.vue'
import TextField from '@/components/TextField.vue'

export default {
	name: 'PartialAuthVerify',
	components: {
		Button,
		NewTippy,
		TextField,
	},
	setup() {
		useHead({
			title: `Verification`
		})

		return {
			userStore: useUserStore(),
		}
	},
	props: {
		routeLink: {
			type: Boolean,
			default: true,
		},
	},
	data: () => ({
		fields: {
			digits: [],
			code: '',
		},
		errorMessage: null,
		viewCode: false,
		totp: {
		},
		otpMethod: 'phone',
		verificationId: null,
	}),
	computed: {
		authData() {
			return this.userStore.authData
		},
		userClaims() {
			return this.userStore.claims
		},
		isLoading() {
			return this.userStore.isLoading
		}
	},
	mounted() {
		this.$el.querySelector(`#code`)?.focus()
		setTimeout(() => {
			tippy('[title]', {
				theme: 'title',
				// placement: 'top',
				maxWidth: '450px',
				delay: [350, 750],
				allowHTML: true,
				content(ref) {
					const title = ref.getAttribute('title')
					ref.removeAttribute('title')
					return title
				}
			})
		}, 250)
	},
	methods: {
		submitForm(fields) {
			console.log('submitForm', this.isLoading)
			if (this.isLoading) return

			this.userStore.authVerify(fields)
				.then(() => {
					this.$router.push({name: 'calculator'})
				})
				.catch(error => {
					this.$nextTick(() => {
						this.fields.code = ''
						this.$el.querySelector(`#code`)?.focus()
					})
					this.errorMessage = error.message || error
				})
		},
		cancel() {
			this.userStore.signOut()
			this.$router.push({name: 'login'})
		},
	},
}
</script>

<style scoped lang="scss">
:deep(.auth-verify__input) {
	font-size: 1.8rem !important;
	font-weight: 500;
	text-align: center !important;
}

.auth-verify {
	max-width: 440px;

	&__codes {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	&__secret {
		letter-spacing: 1px;
	}
}
</style>
